// to fix circular deps
export const mentionize = (username: string) => `@${ username }`
